<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="onCancel()">
            <img src="./assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        <span>{{ "control_catalog_settings_label" | translate }}</span>
    </div>
</web-settings-breadcrumbs>

<div class="panel-options-body overflow-wrapper">
    <div class="form form-horizontal">
        <div class="title">
            {{ "widget_product_settings_general" | translate | uppercase }}
        </div>

        <div class="form-row">
            <div class="form-group mb-0">
                <label class="col-xs-8 control-label">
                    {{ "control_margin_between_cards" | translate }}
                </label>
                <div class="col-xs-4">
                    <sp-input-num
                        suffixText="px"
                        [min]="MARGIN_MIN"
                        [max]="MARGIN_MAX"
                        [onlyIntegers]="true"
                        [value]="generalSettings.controls.margin.value"
                        (valueChange)="setMargin($event)"
                    >
                    </sp-input-num>
                </div>
            </div>
            <div class="form-group mb-0">
                <div class="col-xs-12">
                    <hr class="panel-options-divider" />
                </div>
            </div>
        </div>
        <web-card-settings [cardSettingsFormGroup]="cardSettings"></web-card-settings>
        <web-gallery-settings [gallerySettingsFormGroup]="gallerySettings" [widgetId]="widgetId"></web-gallery-settings>
        <web-typography-settings [typographySettingsFormGroup]="typographySettings"></web-typography-settings>
    </div>
</div>

<web-settings-footer (saveEvent)="onSave()" (cancelEvent)="onReset()"></web-settings-footer>
